import { Component, ElementRef, Inject, OnDestroy, ViewChild } from "@angular/core";
import { Subscription } from "rxjs";
import { Equipment } from "src/app/equipment/equipment";
import { MatDialog, MatSnackBar, MAT_DIALOG_DATA } from "@angular/material";
import { ActivatedRoute, Router } from "@angular/router";
import { DesignService } from "src/app/design/design.service";
import { RoomEntity, SystemEntity } from "src/app/design/design.model";
import { SystemService } from "../system.service";
import { RoomEditDialogComponent } from "src/app/shared/room-edit/room-edit-dialog/room-edit-dialog.component";

@Component({
  selector: "app-new-system-design-room",
  templateUrl: "./new-system-design-room.component.html",
  styleUrls: ["./new-system-design-room.component.css"],
})
export class NewSystemDesignRoomComponent implements OnDestroy {
  private subscription$ = new Subscription();
  display: any = "";
  showLoader: boolean = false;
  equipments: Equipment[];
  addFile: boolean;
  formData = new FormData();
  sys_rooms: any;
  addDone: boolean;
  selectedFileName: any;
  fileNameWithExtention: string;

  design_id: number | string;
  system_id: string;
  systemName: string;
  systemsDesign: SystemEntity;
  room: RoomEntity;
  system : any;

  roomTotal;
  highestDesignTemp;
  remainingCFM;

  constructor(
    private snackBar: MatSnackBar,
    private designService: DesignService,
    private systemService: SystemService,
    private route: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog
  ) {
    this.room = new RoomEntity();
    this.route.queryParams.subscribe((params) => {
      this.design_id = params["design_id"];
      this.system_id = params["system_id"];
      if (this.system_id) {
        this.subscription$.add(
          this.systemService
            .getSingleSystem(this.system_id)
            .subscribe((result: any) => {
              this.systemName = result.system[0].name;
              this.system = result.system[0];

              this.highestDesignTemp = Math.max(this.system.designairflowcool, this.system.designairflowheat);

            })


        );
        this.getRoom();
      }
      if (this.design_id) {
        this.getSystemByDesign(this.design_id);
      }
    });




  }

  /**
   * Get Room
   */
  getRoom() {
    this.subscription$.add(
      this.systemService.getRoom(this.system_id).subscribe((result: any) => {

        console.log(this.sys_rooms);
        this.sys_rooms = [];
        this.sys_rooms = result.room;

        let sum = 0;
        this.sys_rooms.forEach(function(room){
          sum += parseInt(room.dsh_heat_flow);
        });

        this.roomTotal = sum;

        console.log(this.roomTotal);

        console.log(this.highestDesignTemp);

        this.remainingCFM = this.highestDesignTemp - this.roomTotal;

      })
    );
  }

  /**
   * Edit Room
   * @param selectedRoom
   */
  editRoom(selectedRoom: any) {
    const dialogRef = this.dialog.open(RoomEditDialogComponent, {
      width: "500px",
      data: {
        Room: selectedRoom,
      },
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result?.room_id) {
        this.showLoader = true;

        this.systemService.editRoom(result.room_id, result).subscribe(
          (x) => {
            this.showLoader = false;
            this.snackBar.open(`Sucessfully Room Updated `, "", {
              duration: 2000,
            });
          },
          (error) => {
            this.showLoader = false;
            this.snackBar.open(`Error in Updating Room `, "", {
              duration: 2000,
            });
          }
        );
      }
    });
  }

  /**
   * Delete Room
   * @param selectedRoom
   */
  deleteRoom(selectedRoom: any) {
    this.showLoader = true;
    this.systemService.deleteRoom(selectedRoom.room_id).subscribe(
      (x) => {
        this.showLoader = false;
        this.getRoom();
        this.snackBar.open(`Sucessfully Deleted Room `, "", {
          duration: 2000,
        });
      },
      (error) => {
        this.showLoader = false;
        this.snackBar.open(`Error in Deleting Room `, "", {
          duration: 2000,
        });
      }
    );
  }

  ngOnInit() {
    this.addFile = false;

    console.log(this.system);




  }
  /**
   * Get System By Design List
   */
  getSystemByDesign(SystemDesign_id) {
    this.showLoader = true;
    this.subscription$.add(
      this.designService.getSystemByDesignComplete(SystemDesign_id).subscribe(
        (result: any) => {
          if (result) {
            this.systemsDesign = result.Designs;
            this.showLoader = false;
          } else {
            this.showLoader = false;
          }
        },
        (error) => {
          this.showLoader = false;
          this.snackBar.open(`Error in Getting System Design List `, "", {
            duration: 2000,
          });
        }
      )
    );
  }

  /**
   * Uplaod Room File
   * @param files
   * @returns
   */
  uploadFile(files: FileList) {
    if (!files !== null && files.length !== 0) {
      const fileReader = new FileReader();
      fileReader.onloadend = (e) => {};

      fileReader.readAsDataURL(files[0]);
    }
    if (files.length === 0) {
      return;
    }
    // selected image appent into formData

    this.selectedFileName = files[0].name;
    const fileName = files[0].name.split(".")[0];
    const fileExt = files[0].name.split(".")[1];

    this.fileNameWithExtention = fileName + "." + fileExt;
  }

  updateRoomFile() {
    if (!this.fileNameWithExtention?.length) {
      this.showLoader = false;
      this.snackBar.open(`${"Please Must Choose a file"}`, "", {
        duration: 2000,
      });
      return;
    }
    this.systemService
      .uploadImageChecklist(this.fileNameWithExtention)
      .subscribe(() => {
        this.showLoader = false;
        this.systemService
          .roomFile(this.fileNameWithExtention, this.system_id)
          .subscribe(() => {
            this.showLoader = false;
            this.snackBar.open(`${"Room File Updated"}`, "", {
              duration: 2000,
            });
          }),
          (error) => {
            this.showLoader = false;
            this.snackBar.open(`${"Error in Saving Room File"}`, "", {
              duration: 2000,
            });
          };
      }),
      (error) => {
        this.showLoader = false;
        this.snackBar.open(`${"Error in Saving Room File on AWS"}`, "", {
          duration: 2000,
        });
      };
    this.showLoader = false;
  }

  isRequired() {
    return this.addFile ? false : true;
  }

  openErrorModal(message, lessThan): void{

    const dialogRef = this.dialog.open(RoomErrorDialogComponent, {
      width: "500px",
      data: {
        message : message,
        lessThan : lessThan
      }
    });

  }

  /**
   * When Finish is clicked make sure there are at least 3 rooms, and they all add up to the CFM
   */
  checkRooms() : boolean {

    console.log(this.system);

    let done = false;

    if(!this.addFile){

      //make sure ther eare 3 rooms
      if(this.sys_rooms.length > 2){
        console.log('Room is longer than 3');


        if(this.roomTotal != this.highestDesignTemp){
          this.openErrorModal('The cfm of the rooms needs to add up to ' + this.highestDesignTemp + '. Currently the total is ' + this.roomTotal + ' (the difference is ' + Math.abs(this.highestDesignTemp - this.roomTotal) + '). ', true);
          return false;
        }else {
          //design-systems?id=3034&editMode=false
          this.router.navigate(["/design-systems"],
          { queryParams: {id: this.design_id, editMode: false} });
          return true;
        }
      }else {
        console.log();
        this.openErrorModal('There must be at least 3 rooms added, you have ' + this.sys_rooms.length + '.', false);
        return false;
      }

    }else{
      //make sure a file is there
      return true;

    }
  }

  /**
   * Save Room Against System
   */
  addRoom() {
    console.log(this.room);
    this.showLoader = true;
    if (!this.addFile) {
      this.room.hvac_design_id = this.systemsDesign?.hvac_design_id;
      this.room.selection_id = this.system_id;
      this.subscription$.add(
        this.systemService.addNewRoom(this.room).subscribe(
          (data: any) => {
            console.log(this.room);
            this.room.room_descr='';
            this.room.dsh_heat_flow='';
            this.getRoom();

            //see if done

            this.showLoader = false;
            this.snackBar.open(
              `${"System Created Sucessfully with Room"} `,
              "",
              {
                duration: 2000,
              }
            );
          },
          (error) => {
            this.showLoader = false;
            this.snackBar.open(`${"Error in Creating System's Room"}`, "", {
              duration: 2000,
            });
          }
        )
      );
    } else {
      this.updateRoomFile();
    }
  }

  /**
   * unsubscribe the subscriptions
   */

  ngOnDestroy() {
    this.subscription$.unsubscribe();
  }



}

@Component({
  selector: 'room-error-modal',
  templateUrl: 'roomError.html',
})
export class RoomErrorDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public router: Router) {}

  navigateAnyway(): void {
    this.router.navigate(["/system"]);
  }
}
